class RouteModel {
    routeId?: number;
    name?: string;
    morningOrderExpiryTime?: string;
    eveningOrderExpiryTime?: string;
    routeCityId?: number;
    routeCityName?:string;
    unionId?: number;
    unionName?: string;
    morningDepartureTime?: string;
    eveningDepartureTime?: string;
    isLeak?: boolean;
    isActive?: boolean;
}
export default RouteModel;